<script setup lang="ts">
import { useThemeStore } from '@/stores'

const themeStore = useThemeStore()
</script>

<template>
  <div :data-theme="themeStore.isDark ? 'dark' : 'light'">
    <RouterView />
  </div>
</template>
